// This file was auto-generated by Fern from our API Definition.
const ObjectPropertyAccessValues = {
    ReadOnly: "READ_ONLY",
    WriteOnly: "WRITE_ONLY",
};
export const ObjectPropertyAccess = Object.assign(Object.assign({}, ObjectPropertyAccessValues), { _visit: (value, visitor) => {
        switch (value) {
            case ObjectPropertyAccess.ReadOnly:
                return visitor.readOnly();
            case ObjectPropertyAccess.WriteOnly:
                return visitor.writeOnly();
            default:
                return visitor._other();
        }
    } });
